export default "__VITE_ASSET__BTY1Gt2U__"